import React, { useEffect } from 'react'
import { Typography, makeStyles } from '@material-ui/core'
import { connect } from 'react-redux'
import cx from 'classnames'

import { selectMap } from '../../selectors'
import { TYPES } from '../../actions'

import { useLiterals } from '~/components/Literals'

import userCoordImage from '../../assets/here.webp'

// import { createStoreMarker, mountMap, createCustomMarker } from './mapHelper'
import useMapBox from '../../components/useMapBox'

import MapStoresPoints from './MapStoresPoints'
import MapUserLocation from './MapUserLocation'

import styles from './createStyles'

const useStyles = makeStyles(styles)

// init map on this position
const centerBR = { center: { lat: -13.827678, lon: -53.169051 }, zoom: 3.7 }

function getCord(s) {
  return s.coordinates.latlon.split(',').reverse().map(parseFloat)
}

function createIcons(map) {
  map.loadImage(userCoordImage, (error, image) => {
    if (error) {
      return console.error('Error loading user coord image', error)
    }

    map.addImage('user-location', image)
  })
}

function MapContainer({
  currentStore,
  height,
  marginTop,
  mobile: isMobile,
  position: { user },
  setStoreHover,
  storeHover,
  stores,
  view,
  config,
  currentProduct,
  segmentation,
}) {
  const { getLiteral } = useLiterals()
  const classes = useStyles()
  const mapState = useMapBox(centerBR, { onLoad: createIcons })
  const withSidebar = React.useMemo(() => !isMobile && view !== TYPES.VIEW_EMPTY, [isMobile, view])
  const {
    mapRef: { current },
    mapLoaded,
    containerRef,
  } = mapState

  // centraliza o marker da store selecionada
  useEffect(() => {
    if (currentStore) {
      const [lng, lat] = getCord(currentStore)
      current.map.easeTo({
        center: {
          lat: lat || 0,
          lng: lng || 0,
        },
        padding: isMobile ? { bottom: 400, top: 0 } : { top: 300, bottom: 0 },
        zoom: 15.5,
      })
    }
  }, [currentStore, isMobile, current])

  // da um resize no mapa se precisar
  useEffect(() => {
    if (mapLoaded) {
      current.map.resize()
    }
  }, [height, mapLoaded, withSidebar])

  window.mapState = mapState

  return (
    <div className={cx(classes.Map, { withSidebar })}>
      {!currentProduct && view !== TYPES.VIEW_EMPTY && (
        <div
          className={classes.overlayMap}
          style={{ ...(view === TYPES.VIEW_EMPTY ? { left: 0, width: '100%' } : {}) }}
        >
          <Typography variant="body1">{getLiteral('2820')}</Typography>
        </div>
      )}

      {mapLoaded && (
        <>
          <MapUserLocation user={user} mapRef={mapState.mapRef} userCoordinates={user} />
          <MapStoresPoints
            stores={stores}
            segmentation={segmentation}
            user={user}
            mapRef={mapState.mapRef}
            storeHover={storeHover}
            setStoreHover={setStoreHover}
            currentStore={currentStore}
            isMobile={isMobile}
            pin={config?.theme}
            config={config}
            currentProduct={currentProduct}
          />
        </>
      )}
      <div id="map-gofind" ref={containerRef} style={{ height, marginTop }} />
    </div>
  )
}

export default connect(selectMap)(MapContainer)
